import { Alert, Button } from '@mui/material';
import Grid from 'src/components/shared/LegacyGrid';
import axios from 'axios';
import React, { useState } from 'react'
import PageContainer from 'src/components/container/PageContainer'
import CustomFormLabel from 'src/components/forms/theme-elements/CustomFormLabel';
import CustomTextField from 'src/components/forms/theme-elements/CustomTextField';
import BlankCard from 'src/components/shared/BlankCard';
import { formValidation } from 'src/components/Utils/Utils';
import { getCookie } from 'src/Helper/Cokkies';
import { api } from 'src/Helper/Data';
import Breadcrumb from 'src/layouts/full/shared/breadcrumb/Breadcrumb'

const BCrumb = [{ to: '/', title: 'Home' },{ title: 'Bank Account Details' }];

export default function AccountDetails() {
    const [formData, setFormData] = useState({})
      const [submiting, setSubmiting] = useState(false)
      let token = getCookie("token");
      const onchangeFuction = (event) => {setFormData({ ...formData, [event.target.name]: event.target.value })}

      const submitHandler = (e) => {
          setSubmiting(true)
          var filter = /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;
          if (formValidation([formData.companyName, formData.phone, formData.email, formData.pan, formData.pincode, formData.address, formData.city, formData.state, formData.country, formData.pincode])) {
            if (filter.test(formData.email)) {
              axios
                .post(api.url + "/add-company", formData, { headers: { authorization: "Bearer " + token }})
                .then(function (response) {
                  if (response.data.duplicate) {
                    alert(response.data.message);
                    setSubmiting(false)
                  } else if (response.data.partyExceed) {
                    alert(response.data.message);
                    setSubmiting(false)
                  } else {
                    alert("New Company have been Successfully Add");
                  }
                })
                .catch(function (error) {
                  console.log(error);
                });
            } else {
              setSubmiting(false)
              alert("Please enter valid email / contact");
            }
          } else {
            setSubmiting(false)
            alert("Please fill the required fields");
          }
        };

  return (
    <div>
      <PageContainer title="Bank Account Details" description="this is innerpage">
        {/* breadcrumb */}
        <Breadcrumb title="Bank Account Details" items={BCrumb} />
        {/* end breadcrumb */}

        <BlankCard className="p-3">
          <Alert severity="info">Bank Info</Alert>
          <Grid container spacing={3} sx={{
            mb: 2
          }}>

            <Grid item md={6} sm={12}>
              <CustomFormLabel sx={{ mt: 0 }} htmlFor="beneficiaryName">Beneficiary Name</CustomFormLabel>
              <CustomTextField id="beneficiaryName" value={formData.beneficiaryName} onChange={onchangeFuction} placeholder="Enter Beneficiary Name..." name="beneficiaryName" variant="outlined" fullWidth  size="small" />
            </Grid>
            <Grid item md={6} sm={12}>
              <CustomFormLabel sx={{ mt: 0 }} htmlFor="account">Account Number</CustomFormLabel>
              <CustomTextField id="account" value={formData.account} onChange={onchangeFuction} placeholder="Enter account No..." name="account" variant="outlined" fullWidth  size="small" />
            </Grid>
            <Grid item md={6} sm={12}>
              <CustomFormLabel sx={{ mt: 0 }} htmlFor="bank">Bank Name</CustomFormLabel>
              <CustomTextField id="bank" value={formData.bank} onChange={onchangeFuction} placeholder="Enter bank No..." name="bank" variant="outlined" fullWidth  size="small" />
            </Grid>
            <Grid item md={6} sm={12}>
              <CustomFormLabel sx={{ mt: 0 }} htmlFor="ifsc">IFSC Code</CustomFormLabel>
              <CustomTextField id="ifsc" value={formData.ifsc} onChange={onchangeFuction} placeholder="Enter ifsc No..." name="ifsc" variant="outlined" fullWidth  size="small" />
            </Grid>
            <Grid item md={6} sm={12}>
              <CustomFormLabel sx={{ mt: 0 }} htmlFor="swift">Swift Code</CustomFormLabel>
              <CustomTextField id="swift" value={formData.swift} onChange={onchangeFuction} placeholder="Enter swift No..." name="swift" variant="outlined" fullWidth  size="small" />
            </Grid>

          </Grid>
            {submiting? <Button variant="contained" color="primary">Submiting</Button> : <Button variant="contained" color="primary" onClick={(e)=>{submitHandler()}}>Submit</Button>}
          
          <Alert severity="info">Address</Alert>
          <Grid container spacing={3} sx={{
            mb: 2
          }}>
            <Grid item sm={12}>
              <CustomFormLabel sx={{ mt: 0 }} htmlFor="address">Address</CustomFormLabel>
              <CustomTextField id="address" value={formData.address} onChange={onchangeFuction} placeholder="Enter address..." name="address" variant="outlined" fullWidth  size="small" />
            </Grid>
          </Grid>
        </BlankCard>
      </PageContainer>
    </div>
  );
}
